import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BurgerMenu from './BurgerMenu';

const links = [
  { to: '/', label: 'Главная' },
  { to: '/portfolio', label: 'Портфолио' },
  { to: '/prices', label: 'Цены и условия' },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const closeMenu = () => setOpen(false);

  return (
    <nav className="relative bg-white px-5 py-5 md:px-10 md:py-7">
      <div className="mx-auto flex max-w-7xl items-center justify-between">
        <Link
          to="/"
          className="relative z-[110] font-serif text-xl font-normal uppercase leading-none tracking-[0.18em] text-black no-underline md:text-[2rem]"
        >
          Idelinks
        </Link>

        <ul className="m-0 hidden list-none items-center gap-10 p-0 md:flex">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className="font-sans text-[0.8125rem] font-normal uppercase tracking-[0.08em] text-black no-underline transition-opacity hover:opacity-60"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <BurgerMenu open={open} onToggle={() => setOpen((prev) => !prev)} />
      </div>

      <div
        className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white transition-opacity duration-300 md:hidden ${
          open ? 'visible opacity-100' : 'invisible pointer-events-none opacity-0'
        }`}
      >
        <ul className="m-0 flex list-none flex-col items-center gap-10 p-0">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                onClick={closeMenu}
                className="font-sans text-sm font-normal uppercase tracking-[0.12em] text-black no-underline"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
